<script>
    import messages from "/core/stores/alertsStore.js";

    import SuccessAlert from "./SuccessAlert.svelte";
    import InfoAlert from "./InfoAlert.svelte";
    import WarningAlert from "./WarningAlert.svelte";
    import DangerAlert from "./DangerAlert.svelte";

    import { slide,fade } from 'svelte/transition';

    function handleCancelAlert(event) {
        messages.deleteByHash(event.detail.hash);
    }

</script>

<div class='row'>
    <div class='col-sm-12 col-md-6 offset-md-6'>
        <section class="alerts-container-box position-fixed top-0 end-0 mt-1 me-1 ms-1">
            {#each $messages as m}
                {#if m.type == 'success'}
                    <div in:slide out:fade>
                        <SuccessAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
                {#if m.type == 'info'}
                    <div in:slide out:fade>
                        <InfoAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
                {#if m.type == 'warning'}
                    <div in:slide out:fade>
                        <WarningAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
                {#if m.type == 'danger'}
                    <div in:slide out:fade>
                        <DangerAlert msg={m} on:cancelalert={handleCancelAlert}/>
                    </div>
                {/if}
            {/each}
        </section>
    </div>
</div>

<style>
    .alerts-container-box {
        z-index: 10000;
    }
</style>